import apiService from './apiService';

export interface CrossSellSite {
  siteCd: string;
  siteNm: string;
}

export type AddonGender = 'any' | 'male' | 'female';

export interface AddonConfig {
  itemNo: number;
  name: string;
  category?: string | null;
  price?: string | null;
  enabled: boolean;
  gender: AddonGender;
  notes: string;
}

export interface AddonConfigPatch {
  enabled?: boolean;
  gender?: AddonGender;
  notes?: string;
}

class CrossSellConfigService {
  async listSites(): Promise<CrossSellSite[]> {
    const res = await apiService.get<{ success: boolean; sites: CrossSellSite[]; error?: string }>(
      '/voice/cross-sell/sites',
    );
    if (!res.success) throw new Error(res.error || 'Salons konnten nicht geladen werden.');
    return res.sites || [];
  }

  async listAddons(siteCd: string): Promise<AddonConfig[]> {
    const res = await apiService.get<{
      success: boolean;
      addons: AddonConfig[];
      error?: string;
    }>(`/voice/cross-sell/addons?site_cd=${encodeURIComponent(siteCd)}`);
    if (!res.success) throw new Error(res.error || 'Zusatzleistungen konnten nicht geladen werden.');
    return res.addons || [];
  }

  async upsertAddon(
    siteCd: string,
    itemNo: number,
    patch: AddonConfigPatch,
  ): Promise<AddonConfig> {
    const res = await apiService.put<{
      success: boolean;
      addon?: AddonConfig;
      error?: string;
    }>('/voice/cross-sell/addons', {
      site_cd: siteCd,
      item_no: itemNo,
      ...patch,
    });
    if (!res.success || !res.addon) {
      throw new Error(res.error || 'Speichern fehlgeschlagen.');
    }
    return res.addon;
  }
}

const crossSellConfigService = new CrossSellConfigService();
export default crossSellConfigService;
